import { CompareSolution } from 'src/types'

import { REMOVE_ALL_COMPARE, SAVE_SEARCH_PAGE_PATH, UPDATE_COMPARE_BY_SLUG } from '../types/compare'

export const updateCompareBySlug = (vendor: CompareSolution, remove: boolean) => {
  return { type: UPDATE_COMPARE_BY_SLUG, payload: { vendor: vendor, remove: remove } }
}

export const removeAllCompares = () => {
  return { type: REMOVE_ALL_COMPARE }
}

export const saveSearchPagePath = (path: string) => {
  return { type: SAVE_SEARCH_PAGE_PATH, payload: { path: path } }
}
